<template>
  <base-section id="theme-features">
    <base-section-heading title="IFEA TREUHAND">
      In Finanzen Eins A – bei uns sind Sie in besten Händen. Als zuverlässige Treuhandfirma bieten wir Ihnen professionelle und massgeschneiderte Dienstleistungen in den Bereichen Buchhaltung, Steuern, Unternehmensberatung und Personalwesen. Wir zeichnen uns durch grosse Leistungsbereitschaft, Flexibilität und hohe Fachkompetenz aus. Durch gezielte Weiterbildung garantieren wir die bestmögliche Beratung und Unterstützung. Vertrauen Sie auf unser Know-how und unsere Professionalität um Ihre Geschäftsfinanzen zu optimieren und Ihre Steuerlast zu minimieren.
      <br>Wir freuen uns auf Sie.
    </base-section-heading>

    <v-container>
      <v-row>
        <v-col
          v-for="(feature, i) in features"
          :id="feature.title"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="feature"
            align="left"
            horizontal
          >
            {{ feature.text }}
          </base-avatar-card>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionThemeFeatures',

    data: () => ({
      features: [
        {
          color: 'primary',
          dark: true,
          title: 'Buchhaltung',
          icon: 'mdi-bookshelf',
          text: 'Sind Sie es leid mit Zahlen zu jonglieren und wollen sich mehr auf Ihr tägliches Geschäft konzentrieren? Dann unterstützen wir Sie gerne dabei! Im Bereich der Buchhaltung bieten wir Ihnen alles aus einer Hand. Vom Einrichten einer geeigneten Softwarelösung bis zur kompletten Buchhaltung. Wir erfüllen Ihre Wünsche, abgestimmt auf Ihre persönlichen Bedürfnisse! Entscheiden Sie selbst, welche Aufgaben für Sie erledigt werden sollen. Wir richten Ihre Buchhaltung ein, erledigen Ihre Monats-, Quartals- und Jahresabschlüsse oder verbuchen Ihre Kreditoren - ganz wie Sie es wünschen! Wir bieten Ihnen auch die Möglichkeit an, über AbaWeb Treuhand direkt online und jederzeit auf Ihre Buchhaltung zuzugreifen.',
        },
        {
          color: 'primary',
          dark: true,
          title: 'Personalwesen',
          icon: 'mdi-account-convert',
          text: 'Sie möchten die Zahlen Ihres Unternehmens in eigenen Händen halten, wissen jedoch nicht genau, wie das Personalwesen zu organisieren ist? Die Verwaltung der Löhne Ihrer Mitarbeiter:innen ist eine komplexe Aufgabe, welches spezielles Wissen und gesetzliches Know-how erfordert. Im Rahmen unserer individuellen Betreuung können wir die Aufgaben übernehmen, welche Sie nicht persönlich erledigen möchten. Wir erstellen die monatlichen Lohnabrechnungen, unterstützen Sie bei Sozialversicherungsabrechnungen und erledigen die Lohnbuchhaltung von A-Z. Durch die Auslagerung des Personalprozesses haben Sie zudem mehr Ressourcen um sich auf Ihr Kerngeschäft zu konzentrieren.',
        },
        {
          color: 'primary',
          dark: true,
          title: 'Unternehmensberatung',
          icon: 'mdi-offer',
          text: 'Im Bereich der Unternehmensberatung bieten wir verschiedene Dienstleistungen an. Vom Start-Up bis zur Nachfolgeregelung unterstützen wir Sie dabei Ihre spezifischen Bedürfnisse zu realisieren und Ihr Unternehmen durch Prozessoptimierungen auf eine neue Stufe zu bringen und Ihre Rentabilität zu steigern. Besonders interessant ist unser Standort in Kreuzlingen auch für Interessenten aus Deutschland. Für ausländische Unternehmen, welche in der Schweiz Fuss fassen wollen, sind wir mit unserer langjährigen Erfahrung Ihr idealer Ansprechpartner. Durch die Zusammenarbeit mit Partnern aus Deutschland können wir Sie kompetent beraten und Sie beim Sprung in den Schweizer Markt unterstützen und begleiten! Auch Firmen aus allen anderen Ländern der EU sind bei uns willkommen.',
        },
        {
          color: 'primary',
          dark: true,
          title: 'Steuerberatung',
          icon: 'mdi-cash-refund',
          text: 'Unsere Steuerberatung richtet sich gezielt an kleine und mittlere Unternehmen. Wir unterstützen Sie bei laufenden steuerlichen Fragestellungen, der Planung sowie bei der fristgerechten Erstellung Ihrer Steuererklärungen. Dabei achten wir auf eine korrekte Umsetzung aller gesetzlichen Vorgaben und nutzen bestehende steuerliche Gestaltungsmöglichkeiten, um Ihre Steuerlast rechtssicher zu optimieren. Mit einer strukturierten und praxisnahen Arbeitsweise sorgen wir für Transparenz und Entlastung – damit Sie sich auf Ihr Unternehmen konzentrieren können.',
        },
      ],
    }),
    mounted () {
      const param = new URLSearchParams(window.location.search)
      if (param.has('focus')) {
        this.$vuetify.goTo('#' + param.get('focus'))
        window.history.pushState({}, document.title, '/ifea')
      }
    },
  }
</script>
